<svg
  width="1920"
  height="649"
  viewBox="0 0 1920 649"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M660.801 464.867H688.693V521.349C688.693 529.051 682.449 535.295 674.747 535.295C667.045 535.295 660.801 529.051 660.801 521.349V464.867Z"
    fill="#201857"
  />
  <path
    d="M712.4 464.867H740.293V521.349C740.293 529.051 734.049 535.295 726.346 535.295C718.644 535.295 712.4 529.051 712.4 521.349V464.867Z"
    fill="#201857"
  />
  <path
    d="M1096.62 469.051H1124.51V521.349C1124.51 529.051 1118.26 535.295 1110.56 535.295C1102.86 535.295 1096.62 529.051 1096.62 521.349V469.051Z"
    fill="#201857"
  />
  <path
    d="M1148.22 469.051H1176.11V521.349C1176.11 529.051 1169.87 535.295 1162.16 535.295C1154.46 535.295 1148.22 529.051 1148.22 521.349V469.051Z"
    fill="#201857"
  />
  <g filter="url(#filter0_di_956_5)">
    <rect
      x="637.5"
      y="54.5"
      width="569"
      height="412"
      rx="22.5"
      stroke="white"
      stroke-width="5"
      shape-rendering="crispEdges"
    />
  </g>
  <g filter="url(#filter1_di_956_5)">
    <rect
      x="646"
      y="64"
      width="553"
      height="392"
      rx="25"
      fill="#FF509F"
      fill-opacity="0.1"
      shape-rendering="crispEdges"
    />
    <rect
      x="648.5"
      y="66.5"
      width="548"
      height="387"
      rx="22.5"
      stroke="white"
      stroke-width="5"
      shape-rendering="crispEdges"
    />
  </g>
  <path d="M914.711 506.914H912.432V522.244H914.711V506.914Z" fill="#185E45" />
  <path
    d="M913.572 509.371C917.615 509.371 920.893 506.121 920.893 502.112C920.893 498.103 917.615 494.854 913.572 494.854C909.528 494.854 906.25 498.103 906.25 502.112C906.25 506.121 909.528 509.371 913.572 509.371Z"
    fill="#FEBC87"
  />
  <path
    d="M913.578 506.914C916.306 506.914 918.519 504.721 918.519 502.016C918.519 499.31 916.306 497.117 913.578 497.117C910.849 497.117 908.637 499.31 908.637 502.016C908.637 504.721 910.849 506.914 913.578 506.914Z"
    fill="#FFDFAD"
  />
  <g clip-path="url(#clip0_956_5)">
    <path
      d="M823.449 525.501L822.625 528.705L821.8 525.501C819.081 514.945 819.401 501.923 822.623 492.062C825.845 501.923 826.165 514.945 823.448 525.501H823.449Z"
      fill="#185E45"
    />
    <path
      d="M822.164 524.403L822.623 527.94L820.998 526.943C815.648 523.662 811.644 513.961 810.719 502.029C816.2 504.043 820.657 512.758 822.164 524.403Z"
      fill="#185E45"
    />
    <path
      d="M824.245 527.019L822.623 528.046L823.067 524.5C824.53 512.828 828.955 504.034 834.428 501.92C833.548 513.868 829.581 523.639 824.243 527.019H824.245Z"
      fill="#185E45"
    />
  </g>
  <g clip-path="url(#clip1_956_5)">
    <path
      d="M1006.14 525.501L1005.32 528.705L1004.5 525.501C1001.78 514.945 1002.1 501.923 1005.32 492.062C1008.54 501.923 1008.86 514.945 1006.14 525.501H1006.14Z"
      fill="#185E45"
    />
    <path
      d="M1004.86 524.403L1005.32 527.94L1003.69 526.943C998.343 523.662 994.339 513.961 993.414 502.029C998.896 504.043 1003.35 512.758 1004.86 524.403Z"
      fill="#185E45"
    />
    <path
      d="M1006.94 527.019L1005.32 528.046L1005.76 524.5C1007.23 512.828 1011.65 504.034 1017.12 501.92C1016.24 513.868 1012.28 523.639 1006.94 527.019H1006.94Z"
      fill="#185E45"
    />
  </g>
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 877.672 497.639)"
    fill="#185E45"
  />
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 873.586 503.002)"
    fill="#185E45"
  />
  <ellipse
    cx="7.14981"
    cy="7.21365"
    rx="7.14981"
    ry="7.21365"
    transform="matrix(-1 0 0 1 882.014 500.32)"
    fill="#185E45"
  />
  <rect
    width="3.82427"
    height="14.555"
    rx="1.91214"
    transform="matrix(-1 0 0 1 873.586 518.449)"
    fill="#185E45"
  />
  <circle
    cx="7.72435"
    cy="7.72435"
    r="7.72435"
    transform="matrix(-1 0 0 1 873.586 512.574)"
    fill="#185E45"
  />
  <ellipse
    cx="7.72435"
    cy="7.66051"
    rx="7.72435"
    ry="7.66051"
    transform="matrix(-1 0 0 1 885.332 509.002)"
    fill="#185E45"
  />
  <ellipse
    cx="7.72435"
    cy="7.66051"
    rx="7.72435"
    ry="7.66051"
    transform="matrix(-1 0 0 1 885.332 509.002)"
    fill="#185E45"
  />
  <ellipse cx="957.894" cy="503.275" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="961.98" cy="508.638" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="952.978" cy="505.446" rx="7.14971" ry="7.21365" fill="#185E45" />
  <rect
    x="954.256"
    y="516.361"
    width="3.82422"
    height="14.555"
    rx="1.91211"
    fill="#185E45"
  />
  <ellipse cx="961.98" cy="518.211" rx="7.72424" ry="7.72435" fill="#185E45" />
  <ellipse cx="950.234" cy="514.575" rx="7.72424" ry="7.66051" fill="#185E45" />
  <ellipse cx="950.234" cy="514.575" rx="7.72424" ry="7.66051" fill="#185E45" />
  <path
    d="M915.067 535.269H782.46C777.652 535.269 773.762 531.373 773.762 526.571V524.831C773.762 522.909 775.319 521.352 777.241 521.352H920.293C922.215 521.352 923.772 522.909 923.772 524.831V526.571C923.772 531.379 919.876 535.269 915.074 535.269H915.067Z"
    fill="#10293A"
  />
  <path
    d="M1050.34 535.269H917.738C912.929 535.269 909.039 531.373 909.039 526.571V524.831C909.039 522.909 910.596 521.352 912.518 521.352H1055.57C1057.49 521.352 1059.05 522.909 1059.05 524.831V526.571C1059.05 531.379 1055.15 535.269 1050.35 535.269H1050.34Z"
    fill="#10293A"
  />
  <path
    d="M559.495 395.262C559.022 394.989 558.477 394.899 557.883 394.953C557.143 391.734 555.525 389.491 553.639 389.491C552.924 389.491 552.245 389.825 551.639 390.401C550.784 388.321 549.487 387 548.032 387C546.577 387 545.286 388.321 544.426 390.401C543.819 389.825 543.14 389.491 542.425 389.491C540.57 389.491 538.97 391.662 538.218 394.802C537.588 394.729 537.006 394.814 536.509 395.099C534.272 396.39 534.557 401.057 537.133 405.525C539.285 409.247 542.346 411.647 544.601 411.605V411.914H552.076V411.72C554.24 411.338 556.925 409.047 558.865 405.689C561.447 401.221 561.726 396.553 559.489 395.262H559.495Z"
    fill="#185E45"
  />
  <path
    d="M510.495 395.291C510.022 395.017 509.477 394.926 508.883 394.981C508.143 391.751 506.525 389.5 504.64 389.5C503.924 389.5 503.245 389.835 502.639 390.412C501.784 388.326 500.487 387 499.032 387C497.577 387 496.286 388.326 495.426 390.412C494.819 389.835 494.14 389.5 493.425 389.5C491.57 389.5 489.97 391.678 489.218 394.828C488.588 394.755 488.006 394.841 487.509 395.127C485.272 396.422 485.557 401.106 488.133 405.589C490.285 409.324 493.346 411.732 495.601 411.69V412H503.076V411.805C505.24 411.422 507.925 409.123 509.865 405.753C512.447 401.27 512.726 396.586 510.489 395.291H510.495Z"
    fill="#185E45"
  />
  <path
    d="M461.495 395.622C461.022 395.338 460.477 395.243 459.883 395.3C459.143 391.941 457.525 389.6 455.639 389.6C454.924 389.6 454.245 389.948 453.639 390.549C452.784 388.379 451.487 387 450.032 387C448.577 387 447.286 388.379 446.426 390.549C445.819 389.948 445.14 389.6 444.425 389.6C442.57 389.6 440.97 391.865 440.218 395.142C439.588 395.066 439.006 395.154 438.509 395.452C436.272 396.799 436.557 401.67 439.133 406.332C441.285 410.217 444.346 412.722 446.601 412.677V413H454.076V412.798C456.24 412.399 458.925 410.008 460.865 406.503C463.447 401.841 463.726 396.97 461.489 395.622H461.495Z"
    fill="#185E45"
  />
  <path
    d="M561.702 420H435.292C430.708 420 427 416.36 427 411.875V410.25C427 408.455 428.484 407 430.317 407H566.683C568.516 407 570 408.455 570 410.25V411.875C570 416.367 566.286 420 561.708 420H561.702Z"
    fill="#10293A"
  />
  <path
    d="M352.989 354H349.011C344.587 354 341 357.707 341 362.28V425.72C341 430.293 344.587 434 349.011 434H352.989C357.413 434 361 430.293 361 425.72V362.28C361 357.707 357.413 354 352.989 354Z"
    fill="#1D1743"
  />
  <path
    d="M111.989 360H108.011C103.587 360 100 363.661 100 368.177V430.823C100 435.339 103.587 439 108.011 439H111.989C116.413 439 120 435.339 120 430.823V368.177C120 363.661 116.413 360 111.989 360Z"
    fill="#1D1743"
  />
  <path
    d="M278.589 172H274.411C269.766 172 266 175.707 266 180.28V243.72C266 248.293 269.766 252 274.411 252H278.589C283.234 252 287 248.293 287 243.72V180.28C287 175.707 283.234 172 278.589 172Z"
    fill="#1D1743"
  />
  <path
    d="M132.589 179H128.411C123.766 179 120 182.661 120 187.177V249.823C120 254.339 123.766 258 128.411 258H132.589C137.234 258 141 254.339 141 249.823V187.177C141 182.661 137.234 179 132.589 179Z"
    fill="#1D1743"
  />
  <path
    d="M484.156 185.672L117.844 186C109.646 186 103 182.296 103 177.732V10.5962C103 6.02558 109.646 2.32824 117.844 2.32824L484.156 2C492.354 2 499 5.70353 499 10.2679V177.404C499 181.974 492.354 185.672 484.156 185.672Z"
    fill="#362C7B"
  />
  <path
    d="M389.558 211H28.4416C22.6749 211 18 215.697 18 221.491V384.509C18 390.303 22.6749 395 28.4416 395H389.558C395.325 395 400 390.303 400 384.509V221.491C400 215.697 395.325 211 389.558 211Z"
    fill="#362C7B"
  />
  <path
    d="M566.112 601.674L99.8885 602C89.4552 602 81 598.317 81 593.777V427.549C81 423.004 89.4552 419.326 99.8885 419.326L566.112 419C576.545 419 585 422.683 585 427.223V593.451C585 597.996 576.545 601.674 566.112 601.674Z"
    fill="#362C7B"
  />
  <g filter="url(#filter2_di_956_5)">
    <path
      d="M372.649 267.097H18.4043V240.055H372.649C378.508 240.055 383.262 244.809 383.262 250.668V256.484C383.262 262.343 378.508 267.097 372.649 267.097Z"
      fill="#CA74E9"
    />
    <mask
      id="mask0_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="18"
      y="240"
      width="366"
      height="28"
    >
      <path
        d="M372.649 267.099H18.4043V240.057H372.649C378.508 240.057 383.262 244.811 383.262 250.67V256.486C383.262 262.345 378.508 267.099 372.649 267.099Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_956_5)">
      <path
        d="M231.315 372.278L434.242 277.822L323.19 190.941L120.264 285.397L231.315 372.278Z"
        fill="#BD59E0"
      />
      <path
        d="M65.2168 291.558L188.283 234.276L173.564 222.762L50.498 280.044L65.2168 291.558Z"
        fill="#BD59E0"
      />
    </g>
  </g>
  <g filter="url(#filter3_di_956_5)">
    <path
      d="M372.649 319.54H18.4043V292.498H372.649C378.508 292.498 383.262 297.252 383.262 303.111V308.927C383.262 314.786 378.508 319.54 372.649 319.54Z"
      fill="#CA74E9"
    />
    <mask
      id="mask1_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="18"
      y="292"
      width="366"
      height="28"
    >
      <path
        d="M372.649 319.538H18.4043V292.496H372.649C378.508 292.496 383.262 297.25 383.262 303.109V308.925C383.262 314.784 378.508 319.538 372.649 319.538Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_956_5)">
      <path
        d="M160.128 458.78L444.008 326.645L293.196 208.666L9.31641 340.802L160.128 458.78Z"
        fill="#BD59E0"
      />
      <path
        d="M-45.7304 346.962L77.3295 289.686L62.6107 278.172L-60.4492 335.448L-45.7304 346.962Z"
        fill="#BD59E0"
      />
    </g>
  </g>
  <g filter="url(#filter4_di_956_5)">
    <path
      d="M372.649 370.653H18.4043V343.611H372.649C378.508 343.611 383.262 348.365 383.262 354.224V360.04C383.262 365.899 378.508 370.653 372.649 370.653Z"
      fill="#CA74E9"
    />
    <mask
      id="mask2_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="18"
      y="343"
      width="366"
      height="28"
    >
      <path
        d="M372.649 370.649H18.4043V343.607H372.649C378.508 343.607 383.262 348.361 383.262 354.221V360.036C383.262 365.896 378.508 370.649 372.649 370.649Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_956_5)">
      <path
        d="M387.715 340.131H17.7949V374.792H387.715V340.131Z"
        fill="#BD59E0"
      />
    </g>
  </g>
  <path
    d="M1549.39 318H1545.61C1541.41 318 1538 324.071 1538 331.559V435.441C1538 442.929 1541.41 449 1545.61 449H1549.39C1553.59 449 1557 442.929 1557 435.441V331.559C1557 324.071 1553.59 318 1549.39 318Z"
    fill="#1D1743"
  />
  <path
    d="M1437.39 314H1433.61C1429.41 314 1426 320.071 1426 327.559V431.441C1426 438.929 1429.41 445 1433.61 445H1437.39C1441.59 445 1445 438.929 1445 431.441V327.559C1445 320.071 1441.59 314 1437.39 314Z"
    fill="#1D1743"
  />
  <path
    d="M1580.46 159H1262.83C1257.76 159 1253.64 163.671 1253.64 169.434V331.566C1253.64 337.329 1257.76 342 1262.83 342H1580.46C1585.53 342 1589.64 337.329 1589.64 331.566V169.434C1589.64 163.671 1585.53 159 1580.46 159Z"
    fill="#362C7B"
  />
  <g filter="url(#filter5_di_956_5)">
    <path
      d="M1565.68 214.616H1253V187.574H1565.68C1570.85 187.574 1575.04 192.328 1575.04 198.187V204.003C1575.04 209.862 1570.85 214.616 1565.68 214.616Z"
      fill="#E974D6"
    />
    <mask
      id="mask3_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1253"
      y="187"
      width="323"
      height="28"
    >
      <path
        d="M1565.67 214.614H1253V187.572H1565.67C1570.85 187.572 1575.04 192.326 1575.04 198.185V204.001C1575.04 209.86 1570.85 214.614 1565.67 214.614Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_956_5)">
      <path
        d="M1440.92 319.795L1620.04 225.339L1522.02 138.459L1342.9 232.915L1440.92 319.795Z"
        fill="#E968D4"
      />
      <path
        d="M1294.32 239.076L1402.94 181.794L1389.95 170.279L1281.33 227.562L1294.32 239.076Z"
        fill="#E968D4"
      />
    </g>
  </g>
  <g filter="url(#filter6_di_956_5)">
    <path
      d="M1565.68 267.06H1253V240.018H1565.68C1570.85 240.018 1575.04 244.772 1575.04 250.631V256.447C1575.04 262.306 1570.85 267.06 1565.68 267.06Z"
      fill="#E974D6"
    />
    <mask
      id="mask4_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1253"
      y="240"
      width="323"
      height="28"
    >
      <path
        d="M1565.67 267.058H1253V240.016H1565.67C1570.85 240.016 1575.04 244.77 1575.04 250.629V256.445C1575.04 262.304 1570.85 267.058 1565.67 267.058Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_956_5)">
      <path
        d="M1378.09 406.298L1628.66 274.162L1495.55 156.184L1244.98 288.319L1378.09 406.298Z"
        fill="#E968D4"
      />
      <path
        d="M1196.39 294.48L1305.01 237.204L1292.02 225.689L1183.4 282.965L1196.39 294.48Z"
        fill="#E968D4"
      />
    </g>
  </g>
  <g filter="url(#filter7_di_956_5)">
    <path
      d="M1565.68 318.173H1253V291.131H1565.68C1570.85 291.131 1575.04 295.885 1575.04 301.744V307.56C1575.04 313.419 1570.85 318.173 1565.68 318.173Z"
      fill="#E974D6"
    />
    <mask
      id="mask5_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1253"
      y="291"
      width="323"
      height="28"
    >
      <path
        d="M1565.67 318.169H1253V291.127H1565.67C1570.85 291.127 1575.04 295.881 1575.04 301.74V307.556C1575.04 313.415 1570.85 318.169 1565.67 318.169Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_956_5)">
      <path
        d="M1578.97 287.652H1252.46V322.313H1578.97V287.652Z"
        fill="#E968D4"
      />
    </g>
  </g>
  <path
    d="M1659.81 362H1663.19C1666.95 362 1670 365.707 1670 370.28V433.72C1670 438.293 1666.95 442 1663.19 442H1659.81C1656.05 442 1653 438.293 1653 433.72V370.28C1653 365.707 1656.05 362 1659.81 362Z"
    fill="#1D1743"
  />
  <path
    d="M1821.81 364H1825.19C1828.95 364 1832 367.707 1832 372.28V435.72C1832 440.293 1828.95 444 1825.19 444H1821.81C1818.05 444 1815 440.293 1815 435.72V372.28C1815 367.707 1818.05 364 1821.81 364Z"
    fill="#1D1743"
  />
  <path
    d="M1626.25 219H1911.75C1916.3 219 1920 223.671 1920 229.434V391.566C1920 397.329 1916.3 402 1911.75 402H1626.25C1621.7 402 1618 397.329 1618 391.566V229.434C1618 223.671 1621.7 219 1626.25 219Z"
    fill="#362C7B"
  />
  <g filter="url(#filter8_di_956_5)">
    <path
      d="M1642.87 274.36H1955.54V247.318H1642.87C1637.69 247.318 1633.5 252.072 1633.5 257.931V263.747C1633.5 269.606 1637.69 274.36 1642.87 274.36Z"
      fill="#35BAC2"
    />
    <mask
      id="mask6_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1633"
      y="247"
      width="323"
      height="28"
    >
      <path
        d="M1642.87 274.36H1955.54V247.318H1642.87C1637.69 247.318 1633.5 252.072 1633.5 257.931V263.747C1633.5 269.606 1637.69 274.36 1642.87 274.36Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_956_5)">
      <path
        d="M1767.62 379.539L1588.5 285.083L1686.52 198.203L1865.64 292.659L1767.62 379.539Z"
        fill="#33D0DA"
      />
      <path
        d="M1914.22 298.82L1805.6 241.538L1818.59 230.023L1927.21 287.306L1914.22 298.82Z"
        fill="#33D0DA"
      />
    </g>
  </g>
  <g filter="url(#filter9_di_956_5)">
    <path
      d="M1642.87 326.806H1955.54V299.764H1642.87C1637.69 299.764 1633.5 304.518 1633.5 310.377V316.193C1633.5 322.052 1637.69 326.806 1642.87 326.806Z"
      fill="#35BAC2"
    />
    <mask
      id="mask7_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1633"
      y="299"
      width="323"
      height="28"
    >
      <path
        d="M1642.87 326.804H1955.54V299.762H1642.87C1637.69 299.762 1633.5 304.516 1633.5 310.375V316.191C1633.5 322.05 1637.69 326.804 1642.87 326.804Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_956_5)">
      <path
        d="M1830.45 466.044L1579.88 333.908L1713 215.93L1963.56 348.065L1830.45 466.044Z"
        fill="#33D0DA"
      />
      <path
        d="M2012.15 354.226L1903.53 296.95L1916.52 285.436L2025.14 342.712L2012.15 354.226Z"
        fill="#33D0DA"
      />
    </g>
  </g>
  <g filter="url(#filter10_di_956_5)">
    <path
      d="M1642.87 377.919H1955.54V350.877H1642.87C1637.69 350.877 1633.5 355.631 1633.5 361.49V367.306C1633.5 373.165 1637.69 377.919 1642.87 377.919Z"
      fill="#35BAC2"
    />
    <mask
      id="mask8_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1633"
      y="350"
      width="323"
      height="28"
    >
      <path
        d="M1642.87 377.917H1955.54V350.875H1642.87C1637.69 350.875 1633.5 355.629 1633.5 361.488V367.304C1633.5 373.163 1637.69 377.917 1642.87 377.917Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask8_956_5)">
      <path d="M1629.57 347.4H1956.08V382.061H1629.57V347.4Z" fill="#33D0DA" />
    </g>
  </g>
  <g filter="url(#filter11_di_956_5)">
    <path
      d="M209.03 473.877L585.979 473.55V446.508L209.03 446.835C199.567 446.835 191.895 450.527 191.895 455.077V465.629C191.895 470.185 199.567 473.871 209.03 473.871V473.877Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask9_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="191"
      y="446"
      width="395"
      height="28"
    >
      <path
        d="M209.026 473.879L585.975 473.552V446.51L209.026 446.837C199.563 446.837 191.891 450.529 191.891 455.079V465.631C191.891 470.187 199.563 473.873 209.026 473.873V473.879Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask9_956_5)">
      <path
        d="M503.961 508.298L622.294 451.022L608.139 439.508L489.807 496.784L503.961 508.298Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter12_di_956_5)">
    <path
      d="M209.03 526.311L585.979 525.983V498.941L209.03 499.269C199.567 499.269 191.895 502.961 191.895 507.511V518.062C191.895 522.619 199.567 526.305 209.03 526.305V526.311Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask10_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="191"
      y="498"
      width="395"
      height="29"
    >
      <path
        d="M209.026 526.311L585.975 525.983V498.941L209.026 499.269C199.563 499.269 191.891 502.961 191.891 507.511V518.062C191.891 522.619 199.563 526.305 209.026 526.305V526.311Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask10_956_5)">
      <path
        d="M518.994 578.748L643.852 518.305L602.392 484.57L477.533 545.014L518.994 578.748Z"
        fill="#FEAC18"
      />
      <path
        d="M418.818 554.8L537.151 497.524L522.996 486.01L404.67 543.286L418.818 554.8Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <g filter="url(#filter13_di_956_5)">
    <path
      d="M209.027 578.66L585.979 578.333V551.291L209.027 551.618C199.566 551.618 191.895 555.31 191.895 559.861V570.412C191.895 574.968 199.566 578.654 209.027 578.654V578.66Z"
      fill="#FFBF4B"
    />
    <mask
      id="mask11_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="191"
      y="551"
      width="395"
      height="28"
    >
      <path
        d="M209.023 578.658L585.975 578.331V551.289L209.023 551.616C199.562 551.616 191.891 555.308 191.891 559.859V570.41C191.891 574.966 199.562 578.652 209.023 578.652V578.658Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask11_956_5)">
      <path
        d="M477.057 680.369L672.148 585.913L565.385 499.039L370.295 593.489L477.057 680.369Z"
        fill="#FEAC18"
      />
      <path
        d="M317.371 599.65L435.683 542.374L421.531 530.859L303.219 588.135L317.371 599.65Z"
        fill="#FEAC18"
      />
    </g>
  </g>
  <path
    d="M158 551.34V605H107V551.34C107 546.729 110.732 543 115.33 543H149.663C154.268 543 157.994 546.736 157.994 551.34H158Z"
    fill="#FCB972"
  />
  <path
    d="M1378.04 611.674L1845.19 612C1855.64 612 1864.11 608.317 1864.11 603.777V437.549C1864.11 433.004 1855.64 429.326 1845.19 429.326L1378.04 429C1367.58 429 1359.11 432.683 1359.11 437.223V603.451C1359.11 607.996 1367.58 611.674 1378.04 611.674Z"
    fill="#362C7B"
  />
  <g filter="url(#filter14_di_956_5)">
    <path
      d="M1706.13 483.785L1359 483.458V456.416L1706.13 456.743C1714.84 456.743 1721.91 460.435 1721.91 464.986V475.537C1721.91 480.093 1714.84 483.779 1706.13 483.779V483.785Z"
      fill="#BA74FF"
    />
    <mask
      id="mask12_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1359"
      y="456"
      width="363"
      height="28"
    >
      <path
        d="M1706.13 483.787L1359.01 483.46V456.418L1706.13 456.745C1714.84 456.745 1721.91 460.437 1721.91 464.987V475.539C1721.91 480.095 1714.84 483.781 1706.13 483.781V483.787Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask12_956_5)">
      <path
        d="M1476.5 512.503L1367.53 455.227L1380.57 443.713L1489.54 500.989L1476.5 512.503Z"
        fill="#AC59FF"
      />
      <path
        d="M1415.86 520.085L1306.89 462.809L1319.92 451.295L1428.89 508.571L1415.86 520.085Z"
        fill="#AC59FF"
      />
    </g>
  </g>
  <g filter="url(#filter15_di_956_5)">
    <path
      d="M1706.13 536.223L1359 535.896V508.854L1706.13 509.181C1714.84 509.181 1721.91 512.873 1721.91 517.423V527.974C1721.91 532.531 1714.84 536.217 1706.13 536.217V536.223Z"
      fill="#BA74FF"
    />
    <mask
      id="mask13_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1359"
      y="508"
      width="363"
      height="29"
    >
      <path
        d="M1706.13 536.221L1359.01 535.894V508.852L1706.13 509.179C1714.84 509.179 1721.91 512.871 1721.91 517.421V527.972C1721.91 532.529 1714.84 536.215 1706.13 536.215V536.221Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask13_956_5)">
      <path
        d="M1454.09 583.373L1339.11 522.93L1377.29 489.195L1492.27 549.639L1454.09 583.373Z"
        fill="#AC59FF"
      />
      <path
        d="M1546.34 559.425L1437.37 502.149L1450.4 490.635L1559.37 547.911L1546.34 559.425Z"
        fill="#AC59FF"
      />
    </g>
  </g>
  <g filter="url(#filter16_di_956_5)">
    <path
      d="M1706.13 588.57L1359 588.243V561.201L1706.13 561.528C1714.84 561.528 1721.9 565.22 1721.9 569.771V580.322C1721.9 584.878 1714.84 588.564 1706.13 588.564V588.57Z"
      fill="#BA74FF"
    />
    <mask
      id="mask14_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="1359"
      y="561"
      width="363"
      height="28"
    >
      <path
        d="M1721.91 588.562L1359.01 588.241V561.199L1721.91 561.68C1721.91 567.366 1721.91 565.218 1721.91 569.769L1721.91 588.562C1715.28 588.556 1717.65 588.559 1706.13 588.562H1721.91Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask14_956_5)">
      <path
        d="M1484.65 690.422L1304.99 595.966L1403.31 509.092L1582.96 603.541L1484.65 690.422Z"
        fill="#AC59FF"
      />
      <path
        d="M1631.7 609.703L1522.75 552.427L1535.78 540.912L1644.73 598.188L1631.7 609.703Z"
        fill="#AC59FF"
      />
    </g>
  </g>
  <g filter="url(#filter17_di_956_5)">
    <path
      d="M1768.11 572.591V615H1817.11V572.591C1817.11 568.947 1813.53 566 1809.11 566H1776.12C1771.7 566 1768.12 568.952 1768.12 572.591H1768.11Z"
      fill="#BA74FF"
    />
  </g>
  <g filter="url(#filter18_di_956_5)">
    <path
      d="M128.543 57.5216L498.753 57.1944V30.1523L128.543 30.4796C123.634 30.4796 119.658 34.1716 119.658 38.7218V49.2732C119.658 53.8296 123.634 57.5155 128.543 57.5155V57.5216Z"
      fill="#F577B0"
    />
    <mask
      id="mask15_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="119"
      y="30"
      width="380"
      height="28"
    >
      <path
        d="M128.543 57.5177L498.753 57.1905V30.1484L128.543 30.4757C123.634 30.4757 119.658 34.1677 119.658 38.7179V49.2693C119.658 53.8257 123.634 57.5115 128.543 57.5115V57.5177Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask15_956_5)">
      <path
        d="M443.286 91.9452L523.314 34.6629L513.744 23.1484L433.717 80.4307L443.286 91.9452Z"
        fill="#F164A4"
      />
    </g>
  </g>
  <g filter="url(#filter19_di_956_5)">
    <path
      d="M128.543 109.961L498.753 109.634V82.5918L128.543 82.919C123.634 82.919 119.658 86.6111 119.658 91.1613V101.713C119.658 106.269 123.634 109.955 128.543 109.955V109.961Z"
      fill="#F577B0"
    />
  </g>
  <g filter="url(#filter20_di_956_5)">
    <path
      d="M128.593 162.307L498.804 161.98V134.938L128.593 135.265C123.685 135.265 119.709 138.957 119.709 143.507V154.058C119.709 158.615 123.685 162.301 128.593 162.301V162.307Z"
      fill="#F577B0"
    />
    <mask
      id="mask16_956_5"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="119"
      y="134"
      width="380"
      height="29"
    >
      <path
        d="M128.595 162.305L498.806 161.978V134.936L128.595 135.263C123.687 135.263 119.711 138.955 119.711 143.505V154.056C119.711 158.613 123.687 162.299 128.595 162.299V162.305Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask16_956_5)">
      <path
        d="M425.132 264.016L557.094 169.566L484.877 82.6855L352.908 177.141L425.132 264.016Z"
        fill="#F164A4"
      />
      <path
        d="M317.111 183.305L397.138 126.022L387.568 114.508L307.541 171.79L317.111 183.305Z"
        fill="#F164A4"
      />
    </g>
  </g>
  <g filter="url(#filter21_di_956_5)">
    <rect x="1753.11" y="518" width="79" height="28" rx="8" fill="#BA74FF" />
  </g>
  <g filter="url(#filter22_di_956_5)">
    <rect x="1753.11" y="471" width="79" height="28" rx="8" fill="#BA74FF" />
  </g>
  <path
    d="M1422.85 400.561C1422.58 400.534 1422.3 400.561 1422.03 400.632C1422.05 400.212 1422.08 399.786 1422.08 399.349C1422.08 394.218 1420.03 390.053 1417.5 390.053C1416.68 390.053 1415.92 390.496 1415.26 391.26C1414.8 387.106 1412.98 384 1410.8 384C1408.78 384 1407.08 386.653 1406.47 390.326C1405.93 389.862 1405.32 389.606 1404.7 389.606C1402.18 389.606 1400.13 393.765 1400.13 398.902C1400.13 399.415 1400.16 399.917 1400.2 400.408C1399.71 400.201 1399.23 400.119 1398.76 400.179C1396.28 400.512 1395.28 404.879 1396.55 409.928C1397.81 414.977 1400.85 418.803 1403.33 418.465C1403.61 418.427 1403.88 418.329 1404.12 418.192V418.967H1418.14V418.378C1418.54 418.722 1418.98 418.94 1419.48 418.989C1421.98 419.235 1424.76 415.31 1425.69 410.223C1426.63 405.135 1425.35 400.812 1422.85 400.567V400.561Z"
    fill="#185E45"
  />
  <path
    d="M1520.95 400.561C1520.69 400.534 1520.42 400.561 1520.16 400.632C1520.19 400.212 1520.21 399.786 1520.21 399.349C1520.21 394.218 1518.22 390.053 1515.78 390.053C1514.99 390.053 1514.25 390.496 1513.61 391.26C1513.17 387.106 1511.41 384 1509.3 384C1507.36 384 1505.71 386.653 1505.12 390.326C1504.6 389.862 1504.01 389.606 1503.41 389.606C1500.97 389.606 1498.99 393.765 1498.99 398.902C1498.99 399.415 1499.02 399.917 1499.06 400.408C1498.59 400.201 1498.12 400.119 1497.67 400.179C1495.27 400.512 1494.31 404.879 1495.53 409.928C1496.75 414.977 1499.68 418.803 1502.08 418.465C1502.36 418.427 1502.61 418.329 1502.85 418.192V418.967H1516.41V418.378C1516.79 418.722 1517.22 418.94 1517.69 418.989C1520.11 419.235 1522.8 415.31 1523.7 410.223C1524.61 405.135 1523.37 400.812 1520.95 400.567V400.561Z"
    fill="#185E45"
  />
  <path
    d="M1471.95 400.561C1471.69 400.534 1471.42 400.561 1471.16 400.632C1471.19 400.212 1471.21 399.786 1471.21 399.349C1471.21 394.218 1469.22 390.053 1466.78 390.053C1465.99 390.053 1465.25 390.496 1464.61 391.26C1464.17 387.106 1462.41 384 1460.3 384C1458.36 384 1456.71 386.653 1456.12 390.326C1455.6 389.862 1455.01 389.606 1454.41 389.606C1451.97 389.606 1449.99 393.765 1449.99 398.902C1449.99 399.415 1450.02 399.917 1450.06 400.408C1449.59 400.201 1449.12 400.119 1448.67 400.179C1446.27 400.512 1445.31 404.879 1446.53 409.928C1447.75 414.977 1450.68 418.803 1453.08 418.465C1453.36 418.427 1453.61 418.329 1453.85 418.192V418.967H1467.41V418.378C1467.79 418.722 1468.22 418.94 1468.69 418.989C1471.11 419.235 1473.8 415.31 1474.7 410.223C1475.61 405.135 1474.37 400.812 1471.95 400.567V400.561Z"
    fill="#185E45"
  />
  <path
    d="M1570.85 400.561C1570.58 400.534 1570.3 400.561 1570.03 400.632C1570.05 400.212 1570.08 399.786 1570.08 399.349C1570.08 394.218 1568.03 390.053 1565.5 390.053C1564.68 390.053 1563.92 390.496 1563.26 391.26C1562.8 387.106 1560.98 384 1558.8 384C1556.78 384 1555.08 386.653 1554.47 390.326C1553.93 389.862 1553.32 389.606 1552.7 389.606C1550.18 389.606 1548.13 393.765 1548.13 398.902C1548.13 399.415 1548.16 399.917 1548.2 400.408C1547.71 400.201 1547.23 400.119 1546.76 400.179C1544.28 400.512 1543.28 404.879 1544.55 409.928C1545.81 414.977 1548.85 418.803 1551.33 418.465C1551.61 418.427 1551.88 418.329 1552.12 418.192V418.967H1566.14V418.378C1566.54 418.722 1566.98 418.94 1567.48 418.989C1569.98 419.235 1572.76 415.31 1573.69 410.223C1574.63 405.135 1573.35 400.812 1570.85 400.567V400.561Z"
    fill="#185E45"
  />
  <path
    d="M1579.7 429H1453.29C1448.71 429 1445 425.36 1445 420.875V419.25C1445 417.455 1446.48 416 1448.32 416H1584.68C1586.52 416 1588 417.455 1588 419.25V420.875C1588 425.367 1584.29 429 1579.71 429H1579.7Z"
    fill="#10293A"
  />
  <path
    d="M1515.7 429H1389.29C1384.71 429 1381 425.36 1381 420.875V419.25C1381 417.455 1382.48 416 1384.32 416H1520.68C1522.52 416 1524 417.455 1524 419.25V420.875C1524 425.367 1520.29 429 1515.71 429H1515.7Z"
    fill="#10293A"
  />
  <defs>
    <filter
      id="filter0_di_956_5"
      x="595"
      y="12"
      width="654"
      height="497"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="2.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 1 0 0 0 0 0.227451 0 0 0 0 0.321569 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter1_di_956_5"
      x="606"
      y="24"
      width="633"
      height="472"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="20" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="7.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.796078 0 0 0 0 0.0941176 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter2_di_956_5"
      x="-15.5957"
      y="206.055"
      width="432.857"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter3_di_956_5"
      x="-15.5957"
      y="258.496"
      width="432.857"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter4_di_956_5"
      x="-15.5957"
      y="309.607"
      width="432.857"
      height="95.0469"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter5_di_956_5"
      x="1219"
      y="157.572"
      width="390.043"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.970833 0 0 0 0 0.473281 0 0 0 0 0.879284 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.929412 0 0 0 0 0.462745 0 0 0 0 0.827451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter6_di_956_5"
      x="1219"
      y="210.016"
      width="390.045"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.970833 0 0 0 0 0.473281 0 0 0 0 0.879284 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.929412 0 0 0 0 0.462745 0 0 0 0 0.827451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter7_di_956_5"
      x="1219"
      y="261.127"
      width="390.045"
      height="95.0469"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.970833 0 0 0 0 0.473281 0 0 0 0 0.879284 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.929412 0 0 0 0 0.462745 0 0 0 0 0.827451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter8_di_956_5"
      x="1599.5"
      y="213.318"
      width="390.043"
      height="95.043"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter9_di_956_5"
      x="1599.5"
      y="265.762"
      width="390.043"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter10_di_956_5"
      x="1599.5"
      y="316.875"
      width="390.043"
      height="95.0449"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.2 0 0 0 0 0.815686 0 0 0 0 0.854902 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter11_di_956_5"
      x="157.895"
      y="412.508"
      width="462.084"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter12_di_956_5"
      x="157.895"
      y="464.941"
      width="462.084"
      height="95.3691"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter13_di_956_5"
      x="157.895"
      y="517.289"
      width="462.084"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.996078 0 0 0 0 0.835294 0 0 0 0 0.27451 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter14_di_956_5"
      x="1325"
      y="422.416"
      width="430.904"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter15_di_956_5"
      x="1325"
      y="474.852"
      width="430.904"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter16_di_956_5"
      x="1325"
      y="527.199"
      width="430.904"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter17_di_956_5"
      x="1734.11"
      y="532"
      width="117"
      height="117"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter18_di_956_5"
      x="85.6582"
      y="0.148438"
      width="447.096"
      height="95.373"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter19_di_956_5"
      x="85.6582"
      y="52.5918"
      width="447.096"
      height="95.3691"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter20_di_956_5"
      x="85.709"
      y="104.936"
      width="447.098"
      height="95.3711"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.984314 0 0 0 0 0.666667 0 0 0 0 0.811765 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.983333 0 0 0 0 0.667847 0 0 0 0 0.810567 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter21_di_956_5"
      x="1719.11"
      y="484"
      width="147"
      height="96"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <filter
      id="filter22_di_956_5"
      x="1719.11"
      y="437"
      width="147"
      height="96"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="17" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_956_5"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_956_5"
        result="shape"
      />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset />
      <feGaussianBlur stdDeviation="12.5" />
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0.67451 0 0 0 0 0.34902 0 0 0 0 1 0 0 0 1 0"
      />
      <feBlend mode="normal" in2="shape" result="effect2_innerShadow_956_5" />
    </filter>
    <clipPath id="clip0_956_5">
      <rect
        width="23.7084"
        height="36.6421"
        fill="white"
        transform="translate(810.719 492.062)"
      />
    </clipPath>
    <clipPath id="clip1_956_5">
      <rect
        width="23.7084"
        height="36.6421"
        fill="white"
        transform="translate(993.414 492.062)"
      />
    </clipPath>
  </defs>
</svg>
